import { createContext } from 'react';

/**
 * @typedef {object} CardHeaderSlots
 * @property {HTMLElement | null} counterSlot - Bottom-bar DOM node for the `x / y` child counter.
 * @property {HTMLElement | null} infoSlot - Bottom-bar DOM node for the info popover icon.
 * @property {HTMLElement | null} filterSlot - Bottom-bar DOM node for the filter icon (DashboardFilterBar).
 * @property {HTMLElement | null} [expandSlot] - Bottom-bar DOM node for the 'Op groot scherm' icon, right of the other icons and left of delete (DashboardCard only).
 */

/**
 * Card wrappers (DashboardCard, AnalysisCardFrame) expose bottom-bar DOM nodes
 * here so inner chart components / card bodies can portal their counter and
 * info icon into the card's bottom bar. `null` when there is no card chrome
 * (e.g. the live-report builder) — consumers fall back to inline rendering.
 *
 * @type {React.Context<CardHeaderSlots | null>}
 */
const CardHeaderSlotContext = createContext(null);

export default CardHeaderSlotContext;
